import script from "./RegisterSplashScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterSplashScreen.vue?vue&type=script&setup=true&lang=js"

import "./RegisterSplashScreen.vue?vue&type=style&index=0&id=5b5952b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b5952b2"]])

export default __exports__